import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../../api/mutations'
import {invalidateSettingsQuery} from '../../../common/providers/ApiInterface'
import type {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils/errorHandling'

export const useUpdateEntityConfig = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<
    void,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.updateEntityConfig>[0]
  >({
    mutationFn: mutations.updateEntityConfig,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.configUpdated'))
    },
    onSettled: (_data, _error, variables) => {
      invalidateSettingsQuery('upmStructure')
      invalidateSettingsQuery('plantConfig', variables.plantUpmId)
      invalidateSettingsQuery(
        'upmEntityConfig',
        variables.plantUpmId,
        variables.entityConfig.metadata.typeUpmId
      )
    }
  })
}
